<template>
  <div>
    <v-btn
      small
      icon
      class="mx-0"
      @click="prev"
    >
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <date-picker
      :value="value"
      type="date"
      format="YYYY-MM-DD"
      lang="zh"
      style="width: 120px"
      clearable
      class="mt-2"
      @input="$emit('input',$event)"
    />
    <v-btn
      small
      icon
      class="mx-0"
      @click="next"
    >
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
</template>
<script>
import dayjs from 'dayjs'
window.dayjs = dayjs
export default {
  props: {
    value: [Date, String, Object],
  },
  data () {
    return {

    }
  },
  methods: {
    prev () {
      this.$emit('input', dayjs(this.value).subtract(1, 'day').toDate())
    },
    next () {
      this.$emit('input', dayjs(this.value).add(1, 'day').toDate())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DatePickerPlus.vue